import { useQuery } from '@tanstack/react-query';
import { queryKeys, accountsService } from '@v2/services';

export const useAccountDetails = (accountId: string | null) => {
  const query = useQuery({
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryKey: queryKeys.accounts.detail(accountId!),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: () => accountsService.getAccountDetails(accountId!),
    enabled: !!accountId,
  });

  return {
    account: query.data ?? null,
    loading: query.isLoading,
    error: query.error instanceof Error ? query.error.message : null,
    refetch: query.refetch,
  };
};

export default useAccountDetails;
